import * as angular from "angular";
import * as _ from "lodash";

declare let google: any;

export class DataTableService {
  constructor() {
  }

  getPivotDataTable(dataTable, rowDimensions, colDimensions, sumIndex) {

    let pivotDataTable = new google.visualization.DataTable(),
      dimensionsGroup = rowDimensions.concat(colDimensions),
      grouped_data = google.visualization.data.group(
        dataTable,
        dimensionsGroup,
        [{'column': sumIndex, 'aggregation': google.visualization.data.sum, 'type': 'number'}]
      ),
      distinctValues = grouped_data.getDistinctValues(dimensionsGroup.length - 1);


    // Set row dimension columns
    _.forEach(rowDimensions, (rowDimension) => {
      pivotDataTable.addColumn(
        {
          label: dataTable.getColumnLabel(rowDimension),
          type: dataTable.getColumnType(rowDimension)
        }
      )
    });

    // Set column dimension columns
    _.forEach(distinctValues, (value) => {
      pivotDataTable.addColumn(
        {label: value, type: 'number'}
      );
    });

    // Init Cells Data
    let lastRowDimensionColumnIndex = rowDimensions.length - 1,
      firstRowDimensionValue,
      lastRowDimensionValue,
      pevotTableRowIndex,
      rowDimensionValues = [];

    _.times(grouped_data.getNumberOfRows(), (rowIndex) => {

      let firstRowDimensionValueToAdd = grouped_data.getValue(rowIndex, rowDimensions[0]),
        lastRowDimensionValueToAdd = grouped_data.getValue(rowIndex, lastRowDimensionColumnIndex),
        columnDimensionKey = grouped_data.getValue(rowIndex, rowDimensions.length),
        columnDimensionValue = grouped_data.getValue(rowIndex, rowDimensions.length + 1),
        columnDimensionIndex = _.findIndex(pivotDataTable.Mf, (col: any) => {
          return col.label === columnDimensionKey
        });

      // Check if last row dimension value different from the new value to add.
      if (!_.isEqual(lastRowDimensionValue, lastRowDimensionValueToAdd) || !_.isEqual(firstRowDimensionValue, firstRowDimensionValueToAdd)) {
        pevotTableRowIndex = pivotDataTable.addRow();
        firstRowDimensionValue = firstRowDimensionValueToAdd;
        lastRowDimensionValue = lastRowDimensionValueToAdd;
        pivotDataTable.setValue(pevotTableRowIndex, lastRowDimensionColumnIndex, lastRowDimensionValueToAdd);

        _.times(rowDimensions.length, (rowDimensionCellIndex) => {
          const value = grouped_data.getValue(rowIndex, rowDimensionCellIndex);

          if (!_.isEqual(rowDimensionValues[rowDimensionCellIndex], value)) {
            rowDimensionValues[rowDimensionCellIndex] = value;
            pivotDataTable.setValue(pevotTableRowIndex, rowDimensionCellIndex, value);
          }
        });

        // Init row's Column Dimension cell values to 0
        _.times(pivotDataTable.Mf.length, (pivotColumnIndex) => {
          if (pivotColumnIndex >= rowDimensions.length) {
            pivotDataTable.setValue(pevotTableRowIndex, pivotColumnIndex, 0);
          }
        });

      }

      // Init row's Column Dimension cell value from group_data - (columnDimensionValue)
      if (columnDimensionIndex !== -1) {
        pivotDataTable.setValue(pevotTableRowIndex, columnDimensionIndex, columnDimensionValue);
      }

    });

    return pivotDataTable;
  }
}

angular
  .module('bringoz.admin.commons')
  .service('dataTableService', DataTableService);
